'use client';

import { useEffect } from 'react';
import * as CookieConsent from 'vanilla-cookieconsent';
import 'vanilla-cookieconsent/dist/cookieconsent.css';
import { useFormat } from 'helpers/hooks/useFormat';
import { useLocale } from 'frontastic/hooks/useLocale';
import getConfig from './CookieConsentConfig';
import { useParams } from 'next/navigation';

const CookieBanner = () => {
  const { locale } = useLocale();
  const { formatMessage } = useFormat({ name: 'common' });
  const countryCode = locale;
  useEffect(() => {
    CookieConsent.run(getConfig(countryCode, formatMessage));
  }, [locale]);
  return null;
};

export default CookieBanner;
